import { RefineClub } from '#src/searchCards/RefineClubs/index.tsx';
import { RefinePosition } from '#src/searchCards/index.ts';
import {
  MatchInfoGroup,
  PlayerGroup,
} from '#src/searchCards/mlb/cardFilters.tsx';

const MAX_TEAM_LIMIT = 30;

export const scoutingCenterMarketFilters = [
  MatchInfoGroup(true),
  PlayerGroup({ withoutActiveClub: true }),
];

export const scoutingCenterMarketDropdownFilters = [
  RefinePosition(),
  RefineClub(MAX_TEAM_LIMIT),
];
